class MapPointFilter {
  constructor(polylineStr) {
    this.boundary = this.parsePolyline(polylineStr);
    this.boundingBox = this.createBoundingBox(this.boundary);
  }

  parsePolyline(polylineStr) {
    return polylineStr.split(";").map(pointStr => {
      const [lon, lat] = pointStr.split(",").map(Number);
      return { lon, lat };
    });
  }

  createBoundingBox(polygon) {
    let minLon = Infinity,
      maxLon = -Infinity;
    let minLat = Infinity,
      maxLat = -Infinity;

    polygon.forEach(point => {
      minLon = Math.min(minLon, point.lon);
      maxLon = Math.max(maxLon, point.lon);
      minLat = Math.min(minLat, point.lat);
      maxLat = Math.max(maxLat, point.lat);
    });

    return { minLon, maxLon, minLat, maxLat };
  }

  isPointInMap(point) {
    // 快速边界检查
    if (
      point.lon < this.boundingBox.minLon ||
      point.lon > this.boundingBox.maxLon ||
      point.lat < this.boundingBox.minLat ||
      point.lat > this.boundingBox.maxLat
    ) {
      return false;
    }

    // 精确多边形检查
    return this.isPointInPolygon(point, this.boundary);
  }

  isPointInPolygon(point, polygon) {
    const x = point.lon,
      y = point.lat;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lon,
        yi = polygon[i].lat;
      const xj = polygon[j].lon,
        yj = polygon[j].lat;

      if (this.isPointOnSegment(point, polygon[i], polygon[j])) {
        return true;
      }

      const intersect =
        yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

      if (intersect) inside = !inside;
    }

    return inside;
  }

  isPointOnSegment(point, segStart, segEnd) {
    const x = point.lon,
      y = point.lat;
    const x1 = segStart.lon,
      y1 = segStart.lat;
    const x2 = segEnd.lon,
      y2 = segEnd.lat;

    if (
      x < Math.min(x1, x2) ||
      x > Math.max(x1, x2) ||
      y < Math.min(y1, y2) ||
      y > Math.max(y1, y2)
    ) {
      return false;
    }

    return Math.abs((x - x1) * (y2 - y1) - (y - y1) * (x2 - x1)) < 1e-10;
  }

  filterPoints(points, key = "") {
    return points.filter(point => this.isPointInMap(key ? point[key] : point));
  }
}
export default MapPointFilter;

// 使用示例
